import type { FaireProductEntity } from "../../entity_types/product";

export const p_arrmtv54mm: FaireProductEntity = {
  token: "p_arrmtv54mm",
  type: "product",
  name: "Genuine and solid Copper Bead Bracelet",
  brandToken: "b_r3cuwn57s4",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/b41845e5602525d26e108af95a96006a0f16b6e36ab59fbb3095780da8a4425c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b859135bae2e09e59ecc50b14a9304d9c5c20e70edac2fc1ef1d633cfb89fb69.jpeg",
    "https://cdn.faire.com/fastly/fd1950fbe49def41782f42a6b290725899ac48850a6ec7818b5104c1c2ea405c.jpeg",
    "https://cdn.faire.com/fastly/b4a022f3282f7ec8a868fe441285326fec239aba3c93538136c2c7a7aab0e101.jpeg",
    "https://cdn.faire.com/fastly/9c4d50ae48e1be43e897b877a27ef4e8ebceb4188f4bd6f83b0cd9bbb6092ed3.png",
    "https://cdn.faire.com/fastly/986d061a521eb019d0cb20f29aa89295424bae8b1b245a16eab1c59d9076fae3.jpeg",
  ],
  priceDollars: 16.63,
  description:
    "Solid Copper beaded elastic bracelets. \nOption 1: 3mm faceted beads\nOption 2: 4mm round beads\n\nPurported benefits of wearing a copper bracelet include the following:\nRelieves pain and inflammation caused by arthritis.\nSterilizes wounds (due to its antibacterial properties)\nImproves the immune system.\nWorks as an antioxidant.\nPrevents cardiovascular disease.",
  tags: [],
  msrpDollars: 33.26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:10.531Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
